import { fireEvent } from '../../../Utils/fireEvent';

export const viewedScreenEvent = () => {
  fireEvent({
    category: 'viewed_screen',
    screen_name: 'community',
    page_url: window.location.href,
  });
};

export const clickedCardEvent = (section_name, card_name, deeplink) => {
  fireEvent({
    category: 'clicked_card_in_community',
    screen_name: 'community',
    page_url: window.location.href,
    section_name: section_name,
    card_name: card_name,
    deeplink_value: deeplink,
  });
};
export const clickedCtaEvent = (cta, section_name, supportVariable) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'community',
    page_url: window.location.href,
    section_name: section_name,
    cta: cta,
    support_variable: supportVariable ? supportVariable : 'NA',
  });
};
